import React from "react";

function TodoLoading (){
    return (
        <p>Loading TODOs, dont panic!</p>
    );
}

export { TodoLoading }

